export default __webpack_public_path__ + "static/media/imgChoosUs3.9c0795ca.png";